'use client'

// src/components/map/timeline/state.ts
var CURRENT_DATE = new Date((/* @__PURE__ */ new Date()).getFullYear(), 0, 1);
var MONTH_DIVISIONS = 4;
var TIMELINE_MONTHS = Array.from({ length: 12 }).map((_, i) => {
  return new Date(CURRENT_DATE.getFullYear(), i, 1);
});

export {
  MONTH_DIVISIONS,
  TIMELINE_MONTHS
};
//# sourceMappingURL=chunk-GVJNMZ3E.mjs.map